import getIn from 'transmute/getIn';
import { GENERIC_CHANNEL_ID, GENERIC_CHANNEL_NAME } from '../constants/keyPaths';
export const getId = getIn(GENERIC_CHANNEL_ID);
export const getName = getIn(GENERIC_CHANNEL_NAME);